import React from 'react'
import PropTypes from 'prop-types'
import { default as ReactContentLoader } from 'react-content-loader'
import { getColor } from 'src/styles'
import { mergeProps } from 'src/util'
import styles from './ContentLoader.scss'

/**
 * Base content loader component taking svg shapes as children.
 */
const ContentLoader = ({ color, ...domProps }) => (
  <ReactContentLoader
    width="100"
    height="100"
    preserveAspectRatio="xMidYMid slice"
    primaryColor={getColor(color)}
    secondaryColor={getColor(color)}
    speed={2}
    primaryOpacity={0.05}
    secondaryOpacity={0}
    {...mergeProps()({ className: styles.loader }, domProps)}
  />
)

ContentLoader.defaultProps = {
  color: 'dark',
  animate: true,
}

ContentLoader.propTypes = {
  ...ReactContentLoader.propTypes,
  /**
   * The laoder color.
   */
  color: PropTypes.string,
}

export default ContentLoader
